import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'requested-assigned',
  templateUrl: './requested-assigned.component.html',
  styleUrls: ['./requested-assigned.component.scss']
})
export class RequestedAssignedComponent implements OnInit {

  @Input() requested : number;
  @Input() assigned : number;

  constructor() { }

  ngOnInit() {
  }

}

